<template>
  <div style=" border-top: 1px solid #d7d7d7; margin-bottom: 1px; padding: 0px 10px 10px 10px">
    <van-row class="circleTitle">
      <van-col>{{ list.name }}</van-col>
      <van-col @click="infoClick" style="margin-left:7px;" v-show="list.indexParaphrase != ''">
        <img style="width: 21px; height: 21px;" alt="指标释义" src="../../../../static/images/info.png">
      </van-col>
      <van-col :style="{float:'right'}" span="4">
        <div @click="handelDetailClick(quotaCard.indexCode,quotaCard.pageCode)" style="width:100%">
          <img src="../../../../static/images/more.png" style="width:.1rem;height:.16rem" />
        </div>
      </van-col>
    </van-row>
    <div @click="handelDetailClick(quotaCard.indexCode,quotaCard.pageCode)">
      <!-- 只有一个有值的指标展示 -->
      <van-row type="flex" justify="center" class="itemBox" v-if="isOneShow">
        <van-col span="24" class="monthYearBox only">
          <div class="circle one">
            <!-- 运营 -->
            <p v-if="list.yearShow && pageCode === '06'">
              <label>当年</label><span>{{list.year}}</span><label>{{list.yearUnit}}</label>
            </p>
            <!-- 运营 -->
            <p v-if="list.monthShow && pageCode === '06'">
              <label>当月</label><span>{{list.month}}</span><label>{{list.monthUnit}}</label>
            </p>
            <!-- 行政、风控 -->
            <p v-if="(list.monthShow || list.yearShow) && pageCode !== '06'">
              <label>{{list.achievementRateName}}</label><span>{{list.achievementRate}}</span><label>{{list.achievementRateUnit}}</label>
            </p>
            <div v-if="list.targetShow">
              <span class="van-circle-title">{{list.target}} {{list.unit}}</span>
              <span class="van-circle-title font-S014">目标值</span>
            </div>
            <div v-if="list.detectionShow">
              <span class="van-circle-title">{{list.detection}} {{list.unit}}</span>
              <span class="van-circle-title font-S014">监测值</span>
            </div>
          </div>
        </van-col>
      </van-row>
      <van-row type="flex" class="flexBox itemBox" v-else>
        <van-col span="16" class="monthYearBox">
          <div :class="{'circle': true, 'twop': list.yearShow && list.monthShow}">
            <!-- 判断年月的返回值是否为null 显示--或者数字 -->
            <!-- 运营 -->
            <div v-if="list.yearShow && pageCode === '06'">
              <p>
                <label>当年</label>
                <span>{{list.year}} </span>
                <label>{{list.yearUnit}}</label>
              </p>
            </div>
            <!-- 运营 -->
            <div v-if="list.monthShow && pageCode === '06'">
              <p>
                <label>当月</label>
                <span>{{list.month}} </span>
                <label>{{list.monthUnit}}</label>
              </p>
            </div>
            <!-- 行政、风控 -->
            <div v-if="(list.monthShow || list.yearShow) && pageCode !== '06'">
              <p>
                <label>{{list.achievementRateName}}</label>
                <span>{{list.achievementRate}} </span>
                <label>{{list.achievementRateUnit}}</label>
              </p>
            </div>
          </div>
        </van-col>

        <van-col span="8" v-if="list.targetShow" :class="{target: isTarget}">
          <span class="van-circle-title">{{list.target}} {{list.unit}}</span>
          <span class="van-circle-title font-S014">目标值</span>
        </van-col>
        <van-col span="8" v-if="list.detectionShow" :class="{detection: isDetection}">
          <span class="van-circle-title">{{list.detection}} {{list.unit}}</span>
          <span class="van-circle-title font-S014">监测值</span>
        </van-col>
      </van-row>
    </div>
    <van-row class="circleFooter flexBox" type="flex">
      <van-col span="6">{{list.orgName}}</van-col>
      <van-col :style="{textAlign:'right',marginRight:'10px'}" span="18">统计时间：{{list.yearTime}}</van-col>
    </van-row>
    <infoDialog :show="show" :indexParaphrase="indexParaphrase" @confirm="confirm"></infoDialog>
  </div>
</template>

<script>
import { postAction } from '@/utils/api'
import infoDialog from '@/pages/common/infoDialog'
export default {
  name: 'OperateCard',
  data () {
    return {
      list: {
        indexName: ''
      },
      items: [],
      flag: true,
      currentRateA: 0,
      currentRateB: 0,
      // rate: 0,
      onYearV: 0,
      date: '',
      postpath: '',
      dataurl: '',
      delurl: '',
      posturl: '',
      typeData: null,
      dirFlagA: true,
      dirFlagB: true,
      rateColor: '#3399FF',
      rateColorTwo: '#3399FF',
      textA: '0',
      textB: '0',
      rateFlag: false,
      showQuota: {},
      rateNum: 0,
      rateNumTwo: 0,
      show: false,
      indexParaphrase: '',
      isTarget: false,
      isDetection: false,
      isOneShow: false
    }
  },
  components: {
    infoDialog
  },
  props: {
    quotaCard: {
      type: Object,
      default: null
    }
  },
  methods: {
    infoClick () {
      this.show = true
      this.indexParaphrase = this.list.indexParaphrase
    },
    confirm () {
      this.show = false
      console.log(this.show)
    },
    getHomeInfo () {
      var url = '/performance/yeJiOperation/getIndexCard'
      let postData = {
        channelId: '',
        classification: this.quotaCard.pageCode,
        date: '',
        dateType: 3,
        indexId: [this.quotaCard.indexCode],
        level: this.quotaCard.orgLevel,
        orgId: this.quotaCard.orgId,
        rank: this.quotaCard.rank
      }
      var obj = postAction(url, postData)
      obj.then((res) => {
        this.list = res.data
        this.$store.commit('OPE_SET_YEAR_TIME', res.data.yearTime.slice(0, 4))
        this.$store.commit('OPE_SET_MONTH_TIME', res.data.yearTime.slice(5, 7))
        this.typeData = res.datas
        this.$emit('getCardIndex', this.list.name)
        // 修改 目标值 监测值 只有一个时 位置 固定在右边
        if (!this.list.detectionShow && this.list.targetShow) {
          this.isTarget = true
        } else if (!this.list.targetShow && this.list.detectionShow) {
          this.isDetection = true
        }
        // 当年、当月、目标值、监测值空值时，显示为--
        if (this.list.month === null) {
          this.list.month = '--'
        }
        if (this.list.year === null) {
          this.list.year = '--'
        }
        if (this.list.target === null) {
          this.list.target = '--'
        }
        if (this.list.detection === null) {
          this.list.detection = '--'
        }
        if (this.list.achievementRate === null) {
          this.list.achievementRate = '--'
        }
        // 当年、当月、目标值、监测值判断是否只有一个展示判断
        let showParamsArr = [this.list.yearShow, this.list.monthShow, this.list.targetShow, this.list.detectionShow]
        this.isOneShow = showParamsArr.filter(v => v === true).length === 1
      })
    },

    //  跳转详情页面  pageFlag:2表示详情页
    handelDetailClick (indexCode, pageCode) {
      console.log('index:' + indexCode)
      console.log('page:' + pageCode)
      this.$store.commit('OPE_SET_PAGEFLAG', 2)
      this.$store.commit('OPE_SET_KIND', this.quotaCard.pageCode)
      this.$store.commit('OPE_SET_QUOTA', this.quotaCard.indexCode)
      localStorage.setItem('pageFlag', 2)
      sessionStorage.setItem('fromType', '1')
      // 用indexCode截取指标最后两位判断进入的是哪个指标的详情页面(id:11结案 21出险支付 31保全时效 05犹豫期内电话回访)
      this.$router.push({
        path: '/OperateDetail',
        query: {
          indexId: indexCode, // 点击进入详情页传入query值indexId
          moduleId: this.$store.state.user.pageCode,
          time: this.$store.state.ope.time,
          kind: this.$store.state.ope.kind,
          level: this.$store.state.user.level,
          orgId: this.$store.state.user.orgId,
          token: this.$route.query.token,
          tm: this.$route.query.tm
        }
      })
    },
    getNowDate () {
      var date = new Date()
      var year = date.getFullYear()
      var month =
        date.getMonth() + 1 < 10
          ? '0' + date.getMonth() + 1
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minute =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var second =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      var nowDate = '' + year + month + day + hour + minute + second
      return nowDate
    }
  },
  computed: {
    getQuota () {
      return this.$store.state.ope.quota
    },
    pageCode () {
      return this.$store.state.user.pageCode
    }
  },
  watch: {
    pageCode: {
      handler: function (val, oldVal) {
        this.getHomeInfo()
      },
      deep: true
    },
    show (val) {
      if (val) {
        this.$emit('getFlag1', true)
      } else {
        this.$emit('getFlag1', false)
      }
    }
  },
  mounted () {
    this.getHomeInfo()
  }
}
</script>

<style lang="stylus" scoped>
.circle label {
  font-weight: normal;
  font-size: 0.14rem;
}

.circle span {
  font-weight: normal;
  font-size: 0.18rem;
}

.circleHeight {
  padding: 0px 15px 15px 15px;
  background: #fff;
}

.circleTitle {
  font-size: 0.18rem;
  font-weight: 400;
  height: 0.45rem;
  line-height: 0.45rem;
}

.circleTitle div:last-child {
  text-align: right;
  padding-left: 0.04rem;
}

.circleFooter {
  font-size: 0.12rem;
  color: #BDBDBD;
  margin: 12px 0px 2px 2px;
}

.circleHeight>>>.van-circle svg {
  transform: rotate(-90deg);
}

.circleHeight>>>.van-circle__text {
  font-size: 0.15rem;
  font-weight: 600;
}

.van-col.van-col--8 {
  text-align: center;
}

.van-circle-title {
  font-size: 0.18rem;
  display: inherit;
  margin-top: 18px;
  text-align: center;
}
.font-S014{
  font-size: 0.14rem !important;
}
.headerKind {
  display: block;
  width: 100%;
  background: #fff;
  font-size: 0.18rem;
  line-height: 0.4rem;
  color: #3399FF;
}
.contentHeader {
  background: #ffffff;
}
// 修改 目标值 监测值 只有一个时 位置 固定在右边
.target {
  position: relative;
  left: 15px;
}
.detection {
  position: relative;
  left: 15px;
}
.one {
  display:flex;
  justify-content:center;
  span {
    padding: 0 5px;
  }
}
.flexBox {
  flex-wrap: nowrap;
}
.itemBox {
  height: 0.7rem;
}
.monthYearBox {
  display: flex;
  align-items: center;
}
.only {
  justify-content: center;
}
.twop div:nth-child(1) {
  p {
    // margin-top: 0.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/operate/components/OperateCard.vue